import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatCommonModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

import { PepperiModule } from '@pepperi/ngx-lib';
import { PepperiIconModule, PepperiIconRegistry, pepperiIconSystemEdit } from '@pepperi/ngx-lib/icon';
import { PepperiTextboxIconModule } from '@pepperi/ngx-lib/textbox-icon';
import { PepperiFieldTitleModule } from '@pepperi/ngx-lib/field-title';
import { PepperiDialogModule } from '@pepperi/ngx-lib/dialog';

import { PepperiTextareaComponent } from './textarea.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        // Material modules,
        MatCommonModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        // Pepperi modules
        PepperiModule,
        PepperiIconModule,
        PepperiFieldTitleModule,
        PepperiTextboxIconModule,
        PepperiDialogModule
    ],
    exports: [ PepperiTextareaComponent ],
    declarations: [ PepperiTextareaComponent ],
})
export class PepperiTextareaModule {
    constructor(private pepperiIconRegistry: PepperiIconRegistry) {
        this.pepperiIconRegistry.registerIcons([
            pepperiIconSystemEdit
        ]);
    }
}
